import type { U3120Customer } from '../../u3120Customer/U3120Service';
import { unmaskPostalCode } from '../../u2000Core/tools/U2000MaskUtils';
import type { U3121ProjectToSurvey } from '../U3121Service';

const MAX_PTS_STRING = 255;

function truncatePts(value: string | undefined | null): string {
  return String(value ?? '').trim().slice(0, MAX_PTS_STRING);
}

/** True si le client U3120 a une adresse utilisable (ligne rue non vide). */
export function hasUsableCustomerAddress(customer: U3120Customer | null | undefined): boolean {
  return Boolean(customer?.address?.trim());
}

/**
 * Mappe nom + adresse U3120 vers les champs PTS correspondants (owner / adresse / ville / CP / pays / province).
 * N’inclut pas lot, échéances, arpenteur, notes.
 */
export function u3121MapCustomerToPtsAddress(
  customer: U3120Customer,
): Pick<U3121ProjectToSurvey, 'owner' | 'address' | 'city' | 'postalCode' | 'country' | 'state'> {
  const country = customer.country?.id
    ? {
        id: customer.country.id,
        countryNameFr: customer.country.countryNameFr,
        countryNameEn: customer.country.countryNameEn,
        countryCode: customer.country.countryCode,
        countryName: customer.country.countryName,
      }
    : null;

  const state = customer.state?.id
    ? {
        id: customer.state.id,
        stateNameFr: customer.state.stateNameFr,
        stateNameEn: customer.state.stateNameEn,
        stateName: customer.state.stateName,
      }
    : null;

  return {
    owner: truncatePts(customer.customerName),
    address: truncatePts(customer.address),
    city: truncatePts(customer.city),
    postalCode: unmaskPostalCode(String(customer.postalCode ?? '')),
    country,
    state,
  };
}
